import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=92f43980&"
import script from "@/views/Reports/Feedback/Feedback.ts?vue&type=script&lang=ts&"
export * from "@/views/Reports/Feedback/Feedback.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports